export const pages = [
  {
    name: 'QH Search Page',
    pattern: /^\/search\/list\/?$/,
    route: 'search-list',
  },
  {
    name: 'QH Map Page',
    pattern: /^\/search\/map\/?$/,
    route: 'search-map',
  },
  {
    name: 'QH Property Page',
    pattern: /^\/properties\/[0-9]+(\w|-)*\/?$/,
    route: 'property',
  },
  {
    name: 'QH Booking Page',
    pattern: /^\/checkout\/?$/,
    route: 'checkout',
  },
  {
    name: 'QH Booking Confirmation Page',
    pattern: /^\/bookings\/([a-z0-9]|-){0,}\/?$/,
    route: 'booking-confirmation',
  },
  {
    name: 'QH Contact Us Page',
    pattern: /^\/contact-us\/?$/,
    route: 'contact-us',
  },
  {
    name: 'QH Email Us Form Page',
    pattern: /^\/contact-us\/email\/?$/,
    route: 'contact-us-form',
  },
  {
    name: 'QH FAQs Page',
    pattern: /^\/faqs\/?$/,
    route: 'faqs',
  },
  {
    name: 'QH Destination Page',
    pattern: /^\/australia(\/?)(.*)$/,
    route: 'destination',
  },
];

export const statesLookup = {
  'Australian Capital Territory': 'ACT',
  'New South Wales': 'NSW',
  'Northern Territory': 'NT',
  'South Australia': 'SA',
  'Western Australia': 'WA',
  Queensland: 'QLD',
  Tasmania: 'TAS',
  Victoria: 'VIC',
};
